import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {
  HistoricoImportacao,
  ImportacaoService,
} from '../../../services/importacao/importacao-service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-importar-pessoas-historico',
  templateUrl: './importar-pessoas-historico.html',
  styleUrl: './importar-pessoas-historico.scss',
  imports: [
    MatTableModule,
    CommonModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    MatSortModule,
    MatTooltipModule,
    MatIconModule,
  ],
})
export class ImportarPessoasHistorico implements OnInit {
  displayedColumns = [
    'nomeArquivo',
    'dataCriacao',
    'linhasProcessadas',
    'linhasComErro',
    'status',
    'acoes',
  ];

  dataSource = new MatTableDataSource<HistoricoImportacao>([]);
  historico: HistoricoImportacao[] = [];

  filtroTexto = '';
  isLoading = false;

  total = 0;
  pageSize = 10;
  pageSizeOptions = [10, 20, 50];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private importacaoService: ImportacaoService) {}

  async ngOnInit() {
    await this.buscarHistorico();
  }

  async buscarHistorico() {
    this.isLoading = true;

    try {
      const data = await this.importacaoService.buscarHistorico();
      this.historico = data;

      this.dataSource = new MatTableDataSource(this.historico);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.total = this.historico.length;

      this.dataSource.filterPredicate = (item, filter) => {
        const texto = filter.trim().toLowerCase();
        return (
          item.nomeArquivo?.toLowerCase().includes(texto) ||
          item.status?.toLowerCase().includes(texto)
        );
      };
    } catch (error) {
      console.error('Erro ao buscar histórico de importação:', error);
    } finally {
      this.isLoading = false;
    }
  }

  aplicarFiltro() {
    this.dataSource.filter = this.filtroTexto.trim().toLowerCase();
    this.total = this.dataSource.filteredData.length;
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
  }

  get textoContagem(): string {
    return `Mostrando ${this.dataSource.filteredData.length} de ${this.historico.length}`;
  }

  async baixarRelatorioErros(id: number): Promise<void> {
    await this.importacaoService.baixarRelatorio(id);
  }
}
